import {useState} from "react"
import {Document, Page, pdfjs} from "react-pdf"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import 'react-pdf/dist/Page/TextLayer.css';
import {AdaptivityContext} from "./constants";
import {Button, ButtonGroup} from "@vkontakte/vkui";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PDFViewer(props) {
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, setScale] = useState(AdaptivityContext.isMobile ? 0.95 : 0.6);

    function plusScale(e) {
        e.preventDefault()
        setScale(scale < 3 ? scale + 0.1 : 3);
    }

    function minusScale(e) {
        e.preventDefault()
        setScale(scale > 0.3 ? scale - 0.1 : 0.3);
    }

    function prevPage(e) {
        e.preventDefault()
        setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);
    }

    function nextPage(e) {
        e.preventDefault()
        setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);
    }

    function onLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    return (
        <div>
            <ButtonGroup>
                <Button onClick={prevPage} mode="outline">Назад</Button>
                <Button onClick={nextPage} mode="outline">Вперед</Button>
                <Button onClick={plusScale} mode="outline">+</Button>
                <Button onClick={minusScale} mode="outline">-</Button>
            </ButtonGroup>
            <div className="pages">{pageNumber} из {numPages}</div>
            <div className="page">
                <Document className="pdfViewer"
                          file={props.file}
                          onLoadSuccess={onLoadSuccess}
                          renderMode="canvas"

                >
                    <Page width={AdaptivityContext.isMobile ? AdaptivityContext.w : AdaptivityContext.w - 400}
                          height={AdaptivityContext.h}
                          scale={scale}
                          size="A4"
                          key={pageNumber}
                          pageNumber={pageNumber}
                    />
                </Document>
            </div>
        </div>
    )
}